<template>
  <QsSelect
    v-model:model-value="value"
    v-model:select-item="selectItem"
    :option-list="dataList"
    label-field="name"
    :show-disabled="showDisabled"
    disabled-field="enable"
    :get-option-by-id="getListById"
    :style="{ width: selectWidth }"
    add-router-name="ImageLabel"
    @search="search"
    @refresh="refresh"
    @load="load"
    @change="change"
    @clear="clearHandler"
  >
    <template v-if="hasArrowSlot" #arrow-icon>
      <slot name="arrow-icon" />
    </template>
  </QsSelect>
</template>

<script lang="ts" setup>
  import { computed, getCurrentInstance } from 'vue';
  import QsSelect from '@/components/QsSelect/index.vue';
  import useQsSelect from '@/hooks/useQsSelect';
  import { getImageLabelList } from '@/api/imageLabel';

  const instance = getCurrentInstance();

  const props = defineProps({
    modelValue: {
      type: [Number, String],
      required: true,
    },
    selectWidth: {
      type: String,
      default: '100%',
    },
    showDisabled: {
      type: Boolean,
      default: true,
    },
    clearReturnZero: {
      type: Boolean,
      default: false,
    },
  });
  // 判断是否存在名为"arrow-icon"的插槽
  const hasArrowSlot = computed(() => {
    return !!instance?.slots?.['arrow-icon'];
  });
  const value = computed({
    get() {
      return props.modelValue;
    },
    set(e) {
      emit('update:modelValue', e);
    },
  });

  const emit = defineEmits(['update:modelValue']);
  // 根据id请求单个选项 用于默认值回显
  const getListById: any = async (id: number) => {
    const res = await getImageLabelList(
      { enable: 1, id },
      { page: 1, limit: 1 }
    );
    return getOptionById(res);
  };
  // 分页获取选项列表
  const getList: any = (
    data: Record<string, any>,
    params: Record<string, any>
  ) => {
    const { searchKey } = data;
    return getImageLabelList({ enable: 1, name: searchKey }, params);
  };

  const clearHandler = () => {
    if (props.clearReturnZero) {
      emit('update:modelValue', 0);
    }
  };

  const { selectItem, dataList, getOptionById, search, refresh, load, change } =
    useQsSelect({
      getList,
    });

  defineExpose({
    selectItem,
    dataList,
  });
</script>

<script lang="ts">
  export default {
    // 选择图片标签
    name: 'SelectImageLabel', // If you want the include property of keep-alive to take effect, you must name the component
  };
</script>
